import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { bindAll } from '@bibliocommons/utils-react';
import { withOptionalRouter } from 'app/helpers/routing';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { childrenShape, routerShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';

import './PaginationItem.scss';

export class PaginationItem extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick(e) {
    e.preventDefault();

    const { page, handleClick, router } = this.props;

    if (handleClick) {
      return handleClick(page);
    }

    return router?.push(this.getHrefForPage());
  }

  getHrefForPage() {
    const { page, router } = this.props;

    return router
      ? router.createHref({
          query: { ...router.query, page }
        })
      : `#page-${page}`;
  }

  renderContent() {
    const { children, current, disabled, page } = this.props;

    if (disabled || !page) {
      return <span>{children || page}</span>;
    }

    if (current) {
      return (
        <span>
          <span aria-hidden>{children || page}</span>
          <ScreenReaderMessage>
            <FormattedMessage id="pagination_page_current" values={{ page }} />
          </ScreenReaderMessage>
        </span>
      );
    }

    return (
      <Link
        href={this.getHrefForPage()}
        className="pagination-item__link"
        dataKey="page-link"
        data-page={page}
        handleClick={this.handleClick}
      >
        <span aria-hidden>{children || page}</span>
        <ScreenReaderMessage>
          <FormattedMessage id="pagination_page_link" values={{ page }} />
        </ScreenReaderMessage>
      </Link>
    );
  }

  render() {
    const { className, role, current, disabled } = this.props;
    const classNames = cn('cp-pagination-item', className, {
      'pagination-item--disabled': disabled,
      'pagination-item--current': current
    });

    const htmlProps = { role };
    if (current) {
      htmlProps['aria-current'] = 'page';
    }

    return (
      <li className={classNames} {...htmlProps}>
        {this.renderContent()}
      </li>
    );
  }
}

PaginationItem.propTypes = {
  page: PropTypes.number,
  handleClick: PropTypes.func,
  current: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: childrenShape,
  role: PropTypes.string,
  router: routerShape
};

export default withOptionalRouter(PaginationItem);
